const  IMG_PATH = "https://media.vancouver-live.fr/img";
// const  IMG_PATH = "http://localhost/media/img";


export default IMG_PATH;